function checkForElements() {
  let DiscountRadioPrice = document.querySelector(".rc-radio__price");
  if (DiscountRadioPrice) {
    let firstRadioBtn = document.querySelector("#rc-radio1"); 
    let secondRadioBtn = document.querySelector("#rc-radio2"); 
    let OGPrice = document.querySelector(".price__regular"); 

    // Store the original price when the page loads
    let OriginalPrice = OGPrice.lastElementChild.innerText;

    firstRadioBtn.addEventListener('click', function() {
      OGPrice.lastElementChild.innerText = DiscountRadioPrice.innerText;
    });

    secondRadioBtn.addEventListener('click', function() {
      OGPrice.lastElementChild.innerText = OriginalPrice;
    });
  } else {
    setTimeout(checkForElements, 100);
  }
}

checkForElements();